import { Box, Divider, Slider, Stack, Switch, Typography } from '@mui/material'
import { t } from 'i18next'
import _ from 'lodash'
import { useEffect, useState } from 'react'

import Adderss from './AddressFilter.jsx'

const AreaFilter = ({ filters, onChange }) => {
  const marks = [
    {
      value: 5,
      label: '5 Km'
    },
    {
      value: 10,
      label: '10 Km'
    },
    {
      value: 15,
      label: '15 Km'
    },
    {
      value: 20,
      label: '20 Km'
    }
  ]

  const [near, setNear] = useState(false)
  const [positionDefault, setPositionDefault] = useState({
    address: '',
    latitude: null,
    longitude: null
  })
  const [radius, setRadius] = useState(5)
  const [position, setPosition] = useState({
    latitude: null,
    longitude: null
  })

  const getPosition = () => {
    new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject)
    }).then((position) => {
      const { coords = {} } = position
      const { latitude = null, longitude = null } = coords
      setPosition({
        latitude,
        longitude
      })
    })
  }

  const defaultRadius = filters?.nearby?.distance || 5000

  const handleChangeNear = (_, v) => setNear(v)

  const handleRadius = (_, v) => setRadius(v)

  const handleAddressChange = (addressPosition) => {
    if (!near) {
      setPosition(addressPosition)
    }
  }

  useEffect(() => {
    setPosition({
      latitude: null,
      longitude: null
    })

    if (near) {
      getPosition()
    }

    setNear(near)
  }, [near])

  useEffect(() => {
    const { latitude = null, longitude = null } = position

    if (latitude !== null && longitude !== null && radius) {
      onChange({
        nearby: {
          distance: radius * 1000,
          center: _.omit(position, ['address'])
        }
      })
    }

    setPositionDefault(position)
  }, [position, radius])

  useEffect(() => {
    setNear(false)
    setPosition(positionDefault)
    setRadius(defaultRadius / 1000)
  }, [])

  return (
    <>
      <Divider />
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="left"
        spacing={2}
        mt={3}
        mb={3}>
        <Box>
          <Typography
            align="left"
            sx={{ fontWeight: 'bold' }}>
            {t('filters.gateways.area.near.browser.title')}
          </Typography>
          <Typography
            align="left"
            sx={{ fontSize: '.7em' }}>
            {t('filters.gateways.area.near.browser.subtitle')}
          </Typography>
        </Box>
        <Box>
          <Switch
            checked={near}
            slotProps={{ input: { 'aria-label': t('filters.gateways.area.near.browser.title') } }}
            onChange={handleChangeNear}
          />
        </Box>
      </Stack>
      <Divider />
      {!near && (
        <>
          <Stack
            direction="column"
            justifyContent="space-between"
            alignItems="stretch"
            spacing={5}
            mt={3}
            mb={3}>
            <Box>
              <Typography
                align="center"
                variant="h4"
                sx={{ fontWeight: 'bold' }}>
                {t('filters.gateways.area.near.search.title')}
              </Typography>
            </Box>
            <Box>
              <Typography
                align="center"
                sx={{ fontSize: '.7em' }}>
                {t('filters.gateways.area.near.search.subtitle')}
              </Typography>
            </Box>
            <Box>
              <Adderss
                filters={filters}
                onChange={handleAddressChange}
              />
            </Box>
          </Stack>
        </>
      )}
      <Divider />
      <>
        <Stack
          direction="row"
          justifyContent="space-evenly"
          spacing={2}
          mt={3}
          mb={3}>
          <Box>
            <Stack
              direction="column"
              justifyContent="space-evenly"
              spacing={2}
              mt={3}
              mb={3}>
              <Box>
                <Typography
                  align="center"
                  variant="h2"
                  sx={{ fontWeight: 'bold' }}>
                  {t('filters.gateways.area.near.radius.title')}
                </Typography>
              </Box>
            </Stack>
            <Stack
              direction="column"
              justifyContent="fix-start"
              spacing={2}
              mt={3}
              mb={3}>
              <Box>
                <Typography align="center">{t('filters.gateways.area.near.radius.subtitle')}</Typography>
              </Box>
            </Stack>
            <Stack
              direction="column"
              justifyContent="fix-start"
              spacing={2}
              mt={3}
              mb={3}>
              <Box>
                <Typography
                  align="center"
                  variant="h1"
                  sx={{ fontWeight: 'bold' }}>
                  {radius} Km
                </Typography>
              </Box>
            </Stack>
          </Box>
          <Box>
            <Slider
              aria-label="Range radius"
              orientation="vertical"
              getAriaValueText={(value) => {
                return `${value} Km`
              }}
              marks={marks}
              step={1}
              min={1}
              max={20}
              valueLabelDisplay="on"
              onChange={handleRadius}
              value={radius}
              disabled={!position}
            />
          </Box>
        </Stack>
      </>
    </>
  )
}

export default AreaFilter
